var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageEditText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.75C5.5 4.50736 6.50736 3.5 7.75 3.5H16.25C17.4927 3.5 18.5 4.50736 18.5 5.75V11.75C18.5 12.1642 18.8358 12.5 19.25 12.5C19.6642 12.5 20 12.1642 20 11.75V5.75C20 3.67894 18.3211 2 16.25 2H7.75C5.67894 2 4 3.67894 4 5.75V18.25C4 20.3211 5.67894 22 7.75 22H10.75C11.1642 22 11.5 21.6642 11.5 21.25C11.5 20.8358 11.1642 20.5 10.75 20.5H7.75C6.50736 20.5 5.5 19.4927 5.5 18.25V5.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3636 14.6365C19.4264 13.6993 17.9069 13.6993 16.9697 14.6365L13.2197 18.3865C13.079 18.5271 13 18.7179 13 18.9168V21.2502C13 21.6644 13.3358 22.0002 13.75 22.0002H16.0833C16.2822 22.0002 16.473 21.9212 16.6136 21.7806L20.3636 18.0306C21.3009 17.0933 21.3009 15.5738 20.3636 14.6365ZM18.0303 15.6971C18.3817 15.3457 18.9516 15.3457 19.303 15.6971C19.6545 16.0487 19.6545 16.6184 19.303 16.9699L15.7726 20.5002H14.5V19.2275L18.0303 15.6971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.75C8 6.33579 8.33579 6 8.75 6H15.25C15.6642 6 16 6.33579 16 6.75C16 7.16421 15.6642 7.5 15.25 7.5H8.75C8.33579 7.5 8 7.16421 8 6.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10C8.33579 10 8 10.3358 8 10.75C8 11.1642 8.33579 11.5 8.75 11.5H11.25C11.6642 11.5 12 11.1642 12 10.75C12 10.3358 11.6642 10 11.25 10H8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageEditText);
export default __webpack_public_path__ + "static/media/page-edit-text.e1a4886a26ff28dd5e2c100308d87995.svg";
export { ForwardRef as ReactComponent };